import { BRAND } from '@/config/brand';
import { cn } from '@/utils/cn';

type ProductBrandProps = {
  variant?: 'sidebar' | 'light';
  showTagline?: boolean;
  className?: string;
};

export function ProductBrand({ variant = 'light', showTagline = variant === 'sidebar', className }: ProductBrandProps) {
  const isSidebar = variant === 'sidebar';

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <img src="/logo-mark-512.png" alt="" className="w-8 h-8 shrink-0 object-contain" aria-hidden />
      <div className="min-w-0">
        <div className="flex items-center gap-2 flex-wrap">
          <span
            className={cn(
              'font-bold leading-none',
              isSidebar ? 'text-white text-lg' : 'text-foreground text-headline-md'
            )}
          >
            {BRAND.productName}
          </span>
        </div>
        {showTagline && BRAND.productTagline ? (
          <p
            className={cn(
              'mt-1 text-xs font-semibold uppercase tracking-wider',
              isSidebar ? 'text-chrome-muted' : 'text-foreground-muted'
            )}
          >
            {BRAND.productTagline}
          </p>
        ) : null}
      </div>
    </div>
  );
}
